import { render } from "./EditProfile.vue?vue&type=template&id=dff70318&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=dff70318&scoped=true&lang=css"

import exportComponent from "D:\\Data\\Bibliothèque\\Téléchargements\\public\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff70318"]])

export default __exports__